import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner, Label, Input } from 'reactstrap'
import TableContainer from '../../Components/Common/TableContainerReactTable';
import contabilidadDocumentosPendientesHooks from '../../Components/Hooks/ContabilidadDocumentosPendientesHooks';

const ContabilidadDocumentosPendientes = () => {
    const [limit, setLimit] = useState(100);
    const [CLIPRO, setCLIPRO] = useState('');
    const [RAZSOC, setRAZSOC] = useState('');
    const [TIPDOC, setTIPDOC] = useState('');

    const formatDate = (date) => {
        if (!date) return '';
        const _date = new Date(date)
        const year = _date.getFullYear();
        const month = String(_date.getMonth() + 1).padStart(2, '0');
        const day = String(_date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const { documentos, loading, error } = contabilidadDocumentosPendientesHooks(limit, CLIPRO, RAZSOC, TIPDOC);

    useEffect(() => {
        document.title = "Documentos Pendientes | Siga ERP";
    }, []);

    const columns = useMemo(
        () => [
            {
                header: "N° Folio",
                accessorKey: "NUMFOL",
                enableColumnFilter: false,
            },
            {
                header: "RUT Cliente",
                accessorKey: "CLIPRO",
                enableColumnFilter: false,
            },
            {
                header: "Razón social",
                accessorKey: "RAZSOC",
                enableColumnFilter: false,
            },
            {
                header: "Tipo Doc",
                accessorKey: "TIPDOC",
                enableColumnFilter: false,
            },
            {
                header: "N° Doc",
                accessorKey: "NUMDOC",
                enableColumnFilter: false,
            },


            {
                header: "Fecha Doc",
                accessorKey: "FECDOC",
                enableColumnFilter: false,
                cell: ({ getValue }) => formatDate(getValue()),
            },
            {
                header: "Fecha Vencimiento",
                accessorKey: "FECVTO",
                enableColumnFilter: false,
                cell: ({ getValue }) => formatDate(getValue()),
            },
            {
                header: "Observación",
                accessorKey: "OBSERV",
                enableColumnFilter: false,
            },
            {
                header: "Valor Total",
                accessorKey: "VALTOT",
                enableColumnFilter: false,
                cell: ({ getValue }) => getValue() ? getValue().toLocaleString() : '',
            },
            {
                header: "Valor Abonado",
                accessorKey: "VALABO",
                enableColumnFilter: false,
                cell: ({ getValue }) => getValue() ? getValue().toLocaleString() : '',
            },
            {
                header: "Saldo",
                accessorKey: "VALABO",
                enableColumnFilter: false,
                cell: ({ row }) => {
                    const valTot = row.original.VALTOT || 0;
                    const valAbo = row.original.VALABO || 0;
                    const saldo = valTot - valAbo;
                    return saldo.toLocaleString();
                },
            },
            {
                header: "Días Retraso",
                enableColumnFilter: false,
                cell: ({ row }) => {
                    const today = new Date();
                    const dueDate = new Date(row.original.FECVTO);
                    if (today > dueDate) {
                        const diffTime = Math.abs(today - dueDate);
                        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                        return diffDays;
                    }
                    return '';
                },
            },
        ],
        []
    );

    const handleCellClick = (cellInfo) => {
        console.log('Celda clickeada:', cellInfo);
        console.log('Columna:', cellInfo.columnId);
        console.log('Valor:', cellInfo.value);
        console.log('Datos completos de la fila:', cellInfo.rowData);
        switch (cellInfo.columnId) {
            case 'CLIPRO':
                setCLIPRO(cellInfo.value)
                break
            case 'RAZSOC':
                setRAZSOC(cellInfo.value)
                break
            case 'TIPDOC':
                setTIPDOC(cellInfo.value)
                break
            default:
                break
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader className="d-flex justify-content-between align-items-center">
                                    <h5 className="card-title mb-0">Documentos Pendientes</h5>
                                    <div className="d-flex align-items-center">
                                        <Label className="form-label mb-0 me-2">Límite</Label>
                                        <div className="mt-0">
                                            <Input
                                                type="number"
                                                min={1}
                                                value={limit}
                                                onChange={(e) => setLimit(e.target.value)}
                                                style={{ width: '100px' }}
                                            />
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <Row className="mb-3">
                                        <Col md={3}>
                                            <Label for="CLIPRO">RUT Cliente</Label>
                                            <Input
                                                type="text"
                                                id="CLIPRO"
                                                value={CLIPRO}
                                                onChange={(e) => setCLIPRO(e.target.value)}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Label for="RAZSOC">Razón Social</Label>
                                            <Input
                                                type="text"
                                                id="RAZSOC"
                                                value={RAZSOC}
                                                onChange={(e) => setRAZSOC(e.target.value)}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Label for="TIPDOC">Tipo Documento</Label>
                                            <Input
                                                type="text"
                                                id="TIPDOC"
                                                value={TIPDOC}
                                                onChange={(e) => setTIPDOC(e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                    {loading ? <div className="text-center"><Spinner animation="border" variant="primary" /></div> : <TableContainer
                                        columns={(columns || [])}
                                        data={documentos}
                                        customPageSize={15}
                                        isGlobalFilter={true}
                                        SearchPlaceholder='Buscar...'
                                        onCellClick={handleCellClick}
                                    />}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default ContabilidadDocumentosPendientes;